import React from "react";
import { Box, Typography } from "@mui/material";
import { Icon } from "@iconify/react";

/**
 * Empty-state shown when the authenticated user does not have the TPX
 * "Plan" permission. Rendered in place of the Plans AG Grid / header,
 * preserving the Welcome greeting and the closed-month alert above it.
 *
 * Props:
 *  - title?:   heading override (default: "You don't have access to plans")
 *  - message?: supporting copy override
 *  - dense?:   reduces vertical padding for embedded contexts
 */
const NoAccessPlans = ({
  title = "You don't have access to plans",
  message = "Your account doesn't have permission to view plans. Please contact your administrator if you believe this is a mistake.",
  dense = false,
}) => {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        backgroundColor: "#FFFFFF",
        border: "1px solid #919EAB33",
        borderRadius: "12px",
        px: 3,
        py: dense ? 4 : 8,
        gap: 1.5,
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: "50%",
          backgroundColor: "#F4F6F8",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#919EAB",
        }}
      >
        <Icon icon="solar:lock-keyhole-bold-duotone" width={28} height={28} />
      </Box>
      <Typography
        sx={{
          fontSize: "18px",
          fontWeight: 600,
          color: "#212B36",
          lineHeight: "28px",
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: 400,
          color: "#637381",
          lineHeight: "22px",
          maxWidth: 520,
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default NoAccessPlans;
